<template>
  <div>
    <tx-action txType="Claim" />
    <div class="d-flex justify-center mt-16">
      <div class="deposit-box pa-10">
        <c-tx-steps
          class="mt-6"
          borderType="stake"
          :options="[{ step: 1, text: 'Gas option' }]"
          :current="1"
        />
        <confirm @close="$emit('close')" />
      </div>
    </div>
  </div>
</template>

<script>
import TxAction from "@/views/stake/components/tx/TxAction.vue";
import Confirm from "./Confirm.vue";

export default {
  components: {
    TxAction,
    Confirm,
  },
};
</script>
